import {PolymerElement} from '@polymer/polymer/polymer-element.js';
// import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from './ns-event-promo.html';
// import '../../../elements-util/src/ns-bind-html/ns-bind-html.js';
import {events} from '@nuskin/ns-util';
import '@nuskin/ns-style-elements';


/**
 * <p>The ns-event-promo contains the content of the Sales Event landing page.</p>
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-event-promo event-name="demo" test-mode></ns-event-promo>
 *   </template>
 * </demo-snippet>
 *
 * <marked-element>
 *  <div slot="markdown-html">
 *  <script type="text/markdown">
 *
 *  </script>
 * </marked-element>
 */
export class NsEventPromo extends PolymerElement {
    constructor() {
        super();
        this.text = '';
    }

    static get is() {
        return "ns-event-promo";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get properties() {
        return {
            eventName: {
                type: String
            },
            /**
             *
             */
            preEventText: {
                type: String,
                value: "<style>h2 {color: #FF0000}</style><div><h2>The event has not started.</h2></div>"
            },
            /**
             */
            inEventText: {
                type: String,
                value: "<style>h2 {color: #00FF00}</style><div><h2>The event has started. Click button to enter.</h2></div>"
            },
            /**
             */
            postEventText: {
                type: String,
                value: "<style>h2 {color: #0000FF}</style><div><h2>The event has ended.</h2></div>"
            },
            /**
             */
            pausedEventText: {
                type: String,
                value: "<style>h2 {color: #0000FF}</style><div><h2>The event is paused.</h2></div>"
            },
            /**
             */
            testMode: {
                type: Boolean,
                value: false
            }
        }
    }

    ready() {
        super.ready();
        this._initListeners();
        events.publish(events.salesevent.POLL_MARKET_CONFIG, [this.eventName]);
        if (this.eventName) {
            events.publish(events.salesevent.INIT_EVENT_TICKET, [this.eventName]);
        }
    }

    _initListeners() {
        events.getValue(events.salesevent.PRE_EVENT, this._processPreEvent(this), true);
        events.getValue(events.salesevent.IN_EVENT, this._processInEvent(this), true);
        events.getValue(events.salesevent.POST_EVENT, this._processPostEvent(this), true);
        events.getValue(events.salesevent.MARKET_CONFIG_EVENTS, mktConfigEvents => {
            if (mktConfigEvents) {
                if (!this.eventName || !mktConfigEvents.includes(this.eventName)) {
                    this.text = `<div><h4>The selected event, ${this.eventName}, is not active in market configuration.</h4></div>`;
                }
            }
        }, true);
    }

    _processPreEvent(_scope) {
        let scope = _scope;

        return (eventName, paused) => {
            if (eventName === scope.eventName) {
                console.log('PROMO Received PRE Event for:', eventName, 'This eventName', scope.eventName);
                scope.text = paused ? scope.pausedEventText: scope.preEventText;
            }
        };
    }

    _processInEvent(_scope) {
        let scope = _scope;

        return (eventName, paused) => {
            if (eventName === scope.eventName) {
                console.log('PROMO Received IN Event for:', eventName, 'This eventName', scope.eventName);
                scope.text = paused ? scope.pausedEventText : scope.inEventText;
            }
        };
    }

    _processPostEvent(_scope) {
        let scope = _scope;

        return (eventName) => {
            if (eventName === scope.eventName) {
                console.log('PROMO Received POST Event for:', eventName, 'This eventName', scope.eventName);
                scope.text = scope.postEventText;
            }
        };
    }
}

customElements.define(NsEventPromo.is, NsEventPromo);